/**
 * Sanitize an article's body elements
 * @param {array} body
 */
export default function sanitize(body) {
  return body.map((row) => {
    if (row.type === 'markup' && row.html) {
      const modified = row;
      // 'Type' is not a valid attribute for Anchors. AMP articles will not validate.
      modified.html = modified.html.replace(/<a type="[^"]+"/g, '<a ');
      // Update
      return modified;
    }
    return row;
  });
}
